var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("emd-text", { attrs: { "data-testid": "error-title" } }, [
        _vm._v(_vm._s(_vm.$t(`${_vm.getError}.title`))),
      ]),
      _c(
        "emd-text",
        {
          staticClass: "eu-my_4",
          attrs: { size: "medium", "data-testid": "error-description" },
        },
        [_vm._v(_vm._s(_vm.$t(`${_vm.getError}.description`)))]
      ),
      _c(
        "emd-button",
        {
          attrs: {
            color: "primary",
            type: "outline",
            "data-testid": "action-button-retry",
          },
          on: {
            click: function ($event) {
              return _vm.$emit("retry")
            },
          },
        },
        [_c("span", [_vm._v(_vm._s(_vm.$t("retry")))])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }